function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStartedTask = function SvgStartedTask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    "data-name": "Rectangle 1531",
    style: {
      fill: "#0025ba"
    },
    transform: "translate(4.06 4.062)"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Started box"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 172"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    "data-name": "Rectangle 1510",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 2",
    style: {
      opacity: 0.6,
      mixBlendMode: "screen",
      isolation: "isolate",
      clipPath: "url(#a)"
    },
    transform: "translate(-4.06 -4.062)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h.958v68.082H0z",
    "data-name": "Path 2095",
    style: {
      fill: "#535353"
    },
    transform: "rotate(45 40.542 13.665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h.958v68.082H0z",
    "data-name": "Path 2096",
    style: {
      fill: "#535353"
    },
    transform: "rotate(45 39.106 17.133)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h.958v68.082H0z",
    "data-name": "Path 2097",
    style: {
      fill: "#535353"
    },
    transform: "rotate(45 37.669 20.603)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h.958v68.082H0z",
    "data-name": "Path 2098",
    style: {
      fill: "#535353"
    },
    transform: "rotate(45 36.232 24.072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h.958v68.082H0z",
    "data-name": "Path 2099",
    style: {
      fill: "#535353"
    },
    transform: "rotate(45 34.794 27.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h.958v68.082H0z",
    "data-name": "Path 2100",
    style: {
      fill: "#535353"
    },
    transform: "rotate(45 33.357 31.01)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h.958v68.082H0z",
    "data-name": "Path 2101",
    style: {
      fill: "#535353"
    },
    transform: "rotate(45 31.92 34.478)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h.958v68.082H0z",
    "data-name": "Path 2102",
    style: {
      fill: "#535353"
    },
    transform: "rotate(45 30.483 37.947)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h.958v68.082H0z",
    "data-name": "Path 2103",
    style: {
      fill: "#535353"
    },
    transform: "rotate(45 29.046 41.416)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h.958v68.082H0z",
    "data-name": "Path 2104",
    style: {
      fill: "#535353"
    },
    transform: "rotate(45 27.61 44.886)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h.958v68.082H0z",
    "data-name": "Path 2105",
    style: {
      fill: "#535353"
    },
    transform: "rotate(45 26.173 48.354)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h.958v68.082H0z",
    "data-name": "Path 2106",
    style: {
      fill: "#535353"
    },
    transform: "rotate(45 24.736 51.823)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h.958v68.082H0z",
    "data-name": "Path 2107",
    style: {
      fill: "#535353"
    },
    transform: "rotate(45 23.299 55.292)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h.958v68.082H0z",
    "data-name": "Path 2108",
    style: {
      fill: "#535353"
    },
    transform: "rotate(45 21.86 58.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h.958v68.082H0z",
    "data-name": "Path 2109",
    style: {
      fill: "#535353"
    },
    transform: "rotate(45 20.424 62.23)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h.958v68.082H0z",
    "data-name": "Path 2110",
    style: {
      fill: "#535353"
    },
    transform: "rotate(45 18.987 65.698)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h.958v68.082H0z",
    "data-name": "Path 2111",
    style: {
      fill: "#535353"
    },
    transform: "rotate(45 17.55 69.167)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h.958v68.082H0z",
    "data-name": "Path 2112",
    style: {
      fill: "#535353"
    },
    transform: "rotate(45 16.113 72.636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h.958v68.082H0z",
    "data-name": "Path 2113",
    style: {
      fill: "#535353"
    },
    transform: "rotate(45 14.676 76.106)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M333.611 513.089c.129-.2.247-.4.357-.605a7.5 7.5 0 0 0 0-7c-.11-.208-.228-.409-.357-.6s-.267-.385-.413-.569a1.4 1.4 0 0 0-.47 1.83 6.1 6.1 0 0 1 0 5.686 1.4 1.4 0 0 0 .47 1.83c.146-.187.284-.376.413-.572zm-1.588 1.743a1.4 1.4 0 0 0-1.83-.469 6.093 6.093 0 0 1-5.684 0 1.405 1.405 0 0 0-1.831.469 7.53 7.53 0 0 0 1.17.771 7.494 7.494 0 0 0 7 0 8.024 8.024 0 0 0 1.175-.772zm-10.523-1.174a1.4 1.4 0 0 0 .469-1.83 6.1 6.1 0 0 1 0-5.686 1.4 1.4 0 0 0-.469-1.83q-.221.275-.413.569c-.128.2-.248.4-.358.6a7.5 7.5 0 0 0 0 7 7.63 7.63 0 0 0 .771 1.177zm1.174-10.52a1.405 1.405 0 0 0 1.831.469 6.093 6.093 0 0 1 5.684 0 1.4 1.4 0 0 0 1.83-.469 7.719 7.719 0 0 0-1.169-.771 7.5 7.5 0 0 0-7 0c-.207.11-.409.229-.6.357s-.389.267-.572.414z",
    "data-name": "Path 2055",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    },
    transform: "translate(-316.531 -498.164)"
  })));
};
export default SvgStartedTask;